export default __webpack_public_path__ + "static/media/mic_off.392e0a76.svg";